import React, { type FC, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'
import { addToast } from 'components/Toast/Toast'
import { useUserProfile } from 'store'
import { type IMessage } from 'types/interfaces/IMessage'
import { type IProgressInfo } from 'types/interfaces/ITypes'

const SetPrice: FC<{
    message: IMessage
    setMessage: (_message: IMessage) => void
    setPriceModalActive: (val: boolean) => void
    progressInfos: { val: IProgressInfo[] }
    setProgressInfos: (val: IProgressInfo[]) => void
}> = ({
    message,
    setMessage,
    setPriceModalActive,
    progressInfos,
    setProgressInfos
}) => {
    const [tempPrice, setTempPrice] = useState<string>('')

    const { t } = useTranslation()
    const userData = useUserProfile()!

    const priceLimits = userData?.price_limits

    const minMessagePrice =
        priceLimits && 'min_message_price' in priceLimits
            ? Number(priceLimits.min_message_price)
            : 0

    const maxMessagePrice =
        priceLimits && 'max_message_price' in priceLimits
            ? Number(priceLimits.max_message_price)
            : 0

    const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value
        const regex = /^(\d*\.?\d{0,2})$/

        if (regex.test(value)) {
            setTempPrice(value)
        }
    }

    const isPriceValid =
        tempPrice !== '' &&
        Number(tempPrice) >= minMessagePrice &&
        Number(tempPrice) <= maxMessagePrice

    const handleSave = () => {
        const price = Number(tempPrice)

        if (price < minMessagePrice) {
            addToast('error', `${t('minPriceIs')} $${minMessagePrice}`)
            return
        }

        if (price > maxMessagePrice) {
            addToast('error', `${t('maxPriceIs')} $${maxMessagePrice}`)
            return
        }

        const tmpInfo = progressInfos.val.map(info => ({
            ...info,
            locked: true
        }))

        setProgressInfos(tmpInfo)
        setMessage({
            ...message,
            price
        })
        setPriceModalActive(false)
    }

    return (
        <div className='directmessage__price'>
            <div className='directmessage__price__info'>
                <p>
                    {t('minimum')}{' '}
                    <span className='priceRange__min'>
                        ${minMessagePrice}
                    </span>{' '}
                    - {t('maximum')}{' '}
                    <span className='priceRange__max'>
                        ${maxMessagePrice}
                    </span>
                </p>

                <div className='directmessage__price__actions'>
                    <div className='directmessage__price__actions--input'>
                        <input
                            type='number'
                            onChange={handlePriceChange}
                            value={tempPrice}
                        />
                    </div>

                    <Button
                        text={t('save')}
                        color='blue'
                        font='mont-16-bold'
                        width='12'
                        height='5'
                        clickFn={handleSave}
                        disabled={!isPriceValid}
                    />
                </div>
            </div>
        </div>
    )
}

export default SetPrice